import { Agent, AgentStatus } from "~/services/agents";

// A project needs setup until it has at least one agent, and — for an owner,
// who's the only one who can act on it — at least one enabled agent. Returns
// false while the agent list is still loading (undefined) so callers don't
// flash into "needs setup" before data arrives. Datasets are optional: a
// session can start with none attached (its working set is simply empty).
export const useProjectNeedsSetup = (
  attachedAgents: Agent[] | undefined,
  isOwner: boolean
): boolean => {
  if (attachedAgents === undefined) {
    return false;
  }
  const hasEnabledAgent = attachedAgents.some((a) => a.status === AgentStatus.ENABLED);
  return attachedAgents.length === 0 || (isOwner && !hasEnabledAgent);
};
